const SEARCH_DETAIL_COMPONENT = Object.freeze({
    EXISTING : 'EXISTING',
    CUSTOMSEARCH: 'CUSTOMSEARCH'
});

export default SEARCH_DETAIL_COMPONENT;